/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {FireTriggeredActionRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/triggered_action_messages.pb'
import {FireTriggeredActionResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/triggered_action_messages.pb'


export const fireTriggeredAction = (request: FireTriggeredActionRequest, options?: CashRequestOptions) => post<FireTriggeredActionRequest, FireTriggeredActionResponse>("/2.0/cash/fire-triggered-action", request, {...options, rejectOnError: true })